import React from 'react';
import { NavLink } from 'react-router-dom';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

import { Avatar, MCButton } from 'src/components/basic';
import SVGIcon, { BASE_ICONS, GENERAL_ICONS } from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';
import LANG_CONST from 'src/helpers/lang/const';

import { permissions, withRouter, userFullName, lang, scssVariables } from 'src/helpers';

import AlertManager from 'src/components/alert/AlertManager';

import model from './model';
import AppModel from 'src/model';
import Notification from './Notification';
import Personal from './Personal';
import Security from './Security';
import Earning from './Earning';
import ConsultationCharge from './Charges';
import VitalInfo from './VitalInfo';
import Question from './Question';
import Location from './Location';
import Certificate from './Certificate';
import Manager from '../Manager';
import Accounts from './Accounts';
import PaymentDetails from './Payment';
import Invoices from './Invoices';
import Treatments from './Treatments';
import Gallery from './Gallery';
import AppSettings from './AppSettings';

class Settings extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    // AppModel.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    // AppModel.unsubscribe(this.subscription);
  }

  deleteAccount = () => {
    AlertManager.popup(AlertManager.TYPES.WARN, {
      close: false,
      title: LANG_CONST.notice.delete_account,
      cancelButton: {
        label: LANG_CONST.buttons.no,
        action: (actions) => actions.hide()
      },
      actionButton: {
        label: LANG_CONST.buttons.yes,
        loadingLabel: LANG_CONST.buttons.processing,
        action: (actions) => {
          actions.setLoading(true);
          AppModel.removeAccount((err, res, success) => {
            actions.setLoading(false);
            if (success) {
              actions.hide();
            } else {
              alert(`error: ${err}`);
            }
          });
        }
      }
    });
  };

  render() {
    const { children } = this.props;
    const user = model.getUser() || {};
    let name = userFullName(user);
    let avatar = (user.avatar || '').toString().replace('/full_', '/350_');

    const list = permissions.ACTIVE_PAGE_LIST.filter(
      (p) => p.path.includes('setting') && !!p.title
    );
    let menuEnabled = false;

    return (
      <div className={'mc-container-content mc-settings'}>
        <div className={'mc-container-content__body-gap horizontal'}>
          {menuEnabled && (
            <div className={'mc-container-content__body-gap-left'}>
              <div className={'mc-fix-wrap'}>
                <div className={'mc-menu-info mc-p20'}>
                  <div className={'mc-flex-10-col mc-flex-center'}>
                    <Avatar image={avatar} text={name} width={90} height={90} />
                    <div className={'mc-value-620'}>{name}</div>
                    {user.username && <div className={'mc-label-418'}>{user.username}</div>}
                  </div>
                  <div className={'mc-flex-10-col'} style={{ width: '100%' }}>
                    {user.phoneNumber && (
                      <div className={'mc-flex'}>
                        <div className={'mc-value-418 mc-grow'}>{lang.t(LANG_CONST.phone)}</div>
                        <div className={'mc-label-418 mc-text-truncate'}>
                          {formatPhoneNumberIntl(user.phoneNumber.toString())}
                        </div>
                      </div>
                    )}
                    <div className={'mc-flex mc-b2t mc-pt10'}>
                      <div className={'mc-value-418 mc-grow'}>{lang.t(LANG_CONST.email)}</div>
                      <div className={'mc-label-418 mc-text-truncate'}>{user.email}</div>
                    </div>
                  </div>

                  <div className={'mc-flex-10-col'} style={{ width: '100%' }}>
                    {list.map((item, index) => (
                      <NavLink key={index} to={item.path} exact={'true'}>
                        <SVGIcon
                          iconname={item.icon}
                          width={40}
                          height={40}
                          fill={scssVariables['colors-mc-heading']}
                        />
                        <span className={'mc-text-truncate'}>
                          {lang.t(typeof item.title === 'string' ? item.title : item.title(user))}
                        </span>
                      </NavLink>
                    ))}
                  </div>
                  <div className={'mc-flex'} style={{ width: '100%' }}>
                    <MCButton
                      label={LANG_CONST.buttons.logout}
                      medium
                      radius
                      quaternary
                      light
                      flex
                      onClick={() => {
                        model.emit('logout');
                      }}
                    />
                  </div>
                  <div className={'mc-flex'} style={{ width: '100%' }}>
                    <MCButton
                      label={LANG_CONST.buttons.delete_account}
                      medium
                      radius
                      senary
                      light
                      flex
                      onClick={this.deleteAccount}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className={'mc-flex-col mc-grow'}>{children}</div>
        </div>
      </div>
    );
  }
}

const MainContainer = withRouter(Settings);

export default {
  SETTING_PERSONAL_PAGE: {
    name: 'setting_personal_page',
    path: '/settings/personal',
    icon: BASE_ICONS.PERSONAL_INFORMATION,
    checkActive: ({ auth }) => !!auth,
    title: (auth) =>
      auth.isClinic ? LANG_CONST.titles.clinic_info : LANG_CONST.titles.profile_info,
    element: (
      <MainContainer>
        <div className={'mc-main-content'}>
          <Personal />
        </div>
      </MainContainer>
    )
  },
  SETTING_SECURITY_PAGE: {
    path: '/settings/security',
    icon: BASE_ICONS.CHANGE_PASSWORD,
    title: LANG_CONST.titles.security,
    name: 'settings_security_page',
    checkActive: ({ auth }) => !!auth,
    element: (
      <MainContainer>
        <Security />
      </MainContainer>
    )
  },
  SETTING_NOTIFICATION_PAGE: {
    path: '/settings/notification',
    icon: BASE_ICONS.NOTIFICATION,
    checkActive: ({ auth }) => !!auth,
    title: LANG_CONST.titles.notification,
    name: 'setting_notification_page',
    element: (
      <MainContainer>
        <div className={'mc-main-content'} style={{ display: 'flex' }}>
          <Notification />
        </div>
      </MainContainer>
    )
  },
  SETTINGS_CHARGES_PAGE: {
    path: '/settings/charges',
    icon: BASE_ICONS.CONSULTATION_CHARGES,
    checkActive: ({ auth }) => !!auth && (auth.isDoctor || auth.isClinic),
    title: () => LANG_CONST.titles.charges,
    name: 'setting_consultation_charges_page',
    element: (
      <MainContainer>
        <ConsultationCharge />
      </MainContainer>
    )
  },
  SETTINGS_QUESTION_PAGE: {
    path: '/settings/question',
    icon: BASE_ICONS.QUESTION,
    checkActive: ({ auth }) => !!auth && auth.isDoctor,
    title: LANG_CONST.titles.appointment_questions,
    name: 'setting_questions_page',
    element: (
      <MainContainer>
        <Question />
      </MainContainer>
    )
  },
  SETTINGS_LOCATION_PAGE: {
    path: '/settings/location',
    icon: BASE_ICONS.LOCATION,
    checkActive: ({ auth }) => !!auth && (auth.isDoctor || auth.isClinic),
    title: () => LANG_CONST.titles.locations,
    name: 'setting_locations_page',
    element: (
      <MainContainer>
        <Location />
      </MainContainer>
    )
  },
  SETTINGS_TREATMENTS_PAGE: {
    path: '/settings/treatments',
    icon: 'treatment-icon',
    checkActive: ({ auth }) => !!auth && auth.isClinic,
    title: LANG_CONST.titles.treatments,
    element: (
      <MainContainer>
        <Treatments />
      </MainContainer>
    )
  },
  SETTINGS_GALLERY_PAGE: {
    path: '/settings/gallery',
    icon: BASE_ICONS.GALLERY,
    checkActive: ({ auth }) => !!auth && auth.isClinic,
    title: LANG_CONST.titles.gallery,
    element: (
      <MainContainer>
        <Gallery />
      </MainContainer>
    )
  },
  SETTINGS_VITAL_PAGE: {
    path: '/settings/vital-info',
    icon: BASE_ICONS.VITAMINS,
    title: LANG_CONST.titles.vital_info,
    checkActive: ({ auth }) => !!auth && auth.isPatient,
    name: 'setting_vital_page',
    element: (
      <MainContainer>
        <VitalInfo />
      </MainContainer>
    )
  },
  SETTINGS_EARNING_PAGE: {
    path: '/settings/earning',
    icon: BASE_ICONS.WALLET,
    title: LANG_CONST.titles.earnings,
    name: 'SETTINGS_EARNING_PAGE',
    checkActive: ({ auth }) => !!auth && auth.isDoctor,
    element: (
      <MainContainer>
        <div className={'mc-main-content'}>
          <Earning />
        </div>
      </MainContainer>
    )
  },
  SETTINGS_CARD_PAGE: {
    path: '/settings/cards',
    icon: BASE_ICONS.WALLET,
    title: LANG_CONST.titles.cards,
    name: 'SETTINGS_CARD_PAGE',
    checkActive: ({ auth }) => !!auth && auth.isPatient,
    element: (
      <MainContainer>
        <div className={'mc-main-content'}>
          <Earning />
        </div>
      </MainContainer>
    )
  },
  SETTINGS_PAYMENT_DETAILS_PAGE: {
    path: '/settings/payment',
    icon: BASE_ICONS.CARD,
    title: LANG_CONST.titles.payment_details,
    name: 'setting_payment_details_page',
    checkActive: ({ auth }) =>
      !!auth && auth.loginInfo?.type !== 'temporary' && (auth.isClinic || auth.isDoctor),
    element: (
      <MainContainer>
        <PaymentDetails />
      </MainContainer>
    )
  },
  SETTINGS_INVOICES_PAGE: {
    path: '/settings/invoices',
    icon: BASE_ICONS.CONSULTATION_CHARGES,
    title: 'Invoices',
    name: 'setting_invoices_page',
    checkActive: ({ auth }) =>
      !!auth &&
      auth.loginInfo?.type !== 'temporary' &&
      (auth.isClinic || (auth.isDoctor && !(auth.clinicIds?.length > 0))),
    element: (
      <MainContainer>
        <Invoices />
      </MainContainer>
    )
  },
  SETTINGS_CERTIFICATE_PAGE: {
    path: '/settings/certificate',
    icon: GENERAL_ICONS.CERTIFICATE,
    checkActive: ({ auth }) => !!auth && (auth.isDoctor || auth.isClinic),
    title: LANG_CONST.titles.certificates,
    name: 'setting_certificate_page',
    element: (
      <MainContainer>
        <Certificate />
      </MainContainer>
    )
  },
  SETTINGS_MANAGER_PAGE: {
    path: '/settings/manager',
    icon: GENERAL_ICONS.MANAGER,
    title: LANG_CONST.titles.managers,
    name: 'setting_manager_page',
    checkActive: ({ auth }) => !!auth && (auth.isClinic || (auth.isManager && auth.managerAdmin)),
    element: (
      <MainContainer>
        <Manager isSetting={true} />
      </MainContainer>
    )
  },
  SETTINGS_ACCOUNTS_PAGE: {
    path: '/settings/accounts',
    icon: BASE_ICONS.PERSONAL_INFORMATION,
    title: LANG_CONST.titles.connected_accounts,
    name: 'setting_accounts_page',
    checkActive: ({ auth }) => !!auth && auth.loginInfo?.type !== 'temporary',
    element: (
      <MainContainer>
        <Accounts />
      </MainContainer>
    )
  },
  SETTINGS_APPSETTINGS_PAGE: {
    path: '/settings/appsettings',
    icon: BASE_ICONS.QUESTION,
    title: LANG_CONST.titles.app_settings,
    name: 'setting_appsettings_page',
    checkActive: ({ auth }) => !!auth && auth.loginInfo?.type !== 'temporary',
    element: (
      <MainContainer>
        <AppSettings />
      </MainContainer>
    )
  }
};
